'use strict';

/*

DEPRECATED: use tabs.js instead

1. Tabs above and contents below

<div class="tabbed-content">

  <div class="tabbed-content__tabs">
    <label class="tabbed-content__tab">
      <input type="radio" name="just-same-random-for-these-radios" value="name-of-content-1" autocomplete="off">
      <span>Text label 1</span>
    </label>
    <label class="tabbed-content__tab">
      <input type="radio" name="just-same-random-for-these-radios" value="name-of-content-2" autocomplete="off">
      <span>Text label 2</span>
    </label>
  </div>

  <div data-tab-content="name-of-content-1" style="display: none;">
    ...
  </div>

  <div data-tab-content="name-of-content-2" style="display: none;">
    ...
  </div>

</div>

2. Tabs without contents but sibling Stage forms

<div class="tabbed-content">

  <div class="tabbed-content__tabs">
    <label class="tabbed-content__tab">
      <input type="radio" name="just-same-random-for-these-radios" autocomplete="off">
      <span>Text label 1</span>
    </label>
    <label class="tabbed-content__tab">
      <input type="radio" name="just-same-random-for-these-radios" autocomplete="off">
      <span>Text label 2</span>
    </label>
  </div>

</div>

Some other content...

<form class="stage-form general">
  ...
</form>

<form class="stage-form general">
  ...
</form>


3. Form with steps
   Step uses native form validation and prevents step change if validation does not pass

<form class="tabbed-content">
  Hidden fields...

  <div data-tab-content="name-of-content-1" style="display: none;">
    Form fields...
    <button data-show-tab-content="name-of-content-2">Go to 2</button>
  </div>

  <div data-tab-content="name-of-content-2" style="display: none;">
    Form fields...
    <button data-show-tab-content="name-of-content-1">Back to 1</button>
    <button data-show-tab-content="name-of-content-3">Go to 3</button>
  </div>

  <div data-tab-content="name-of-content-3" style="display: none;">
    Form fields...
    <button data-show-tab-content="name-of-content-2">Back to 2</button>
    <button type="submit">Submit</button>
  </div>

</form>

*/

import $ from 'jquery';

export class TabbedContent {

  constructor(contentsEl) {
    this.$content = $(contentsEl);
    this.$tabRadios = this._findInThisContent('.tabbed-content__tab input[type="radio"]');
    this.$tabButtons = this._findInThisContent('[data-show-tab-content]');
    this.$tabContents = this._findInThisContent('[data-tab-content]');
    this.$formElements = this._findInThisContent('input, select, textarea');
    this.$formSubmit = this._findInThisContent('button[type=submit]');

    this.isEditor = this.$content.hasClass('is-editor');
    this.contentsAreStageForms = false;

    if(!this.$tabContents.length){
      const hasMultipleForms = this.$content.data('multipleForms') ? true : false;
      this.$tabContents = this.$content.parent().find('form.stage-form.general').slice(0, hasMultipleForms ? this.$tabRadios.length : 1); //if multiple forms, get as many as there is tabs. else get just the first.
      this.contentsAreStageForms = true;
    }

    // Attach event listeners
    this.$tabRadios.on('change', this.onTabChange.bind(this));
    this.$tabButtons.on('click', this.onTabChange.bind(this));
    this.$formElements.on('invalid', this.onTabChange.bind(this));
    // Change submit to button (prevent submit on enter) and submit onClick if form is valid
    this.$formSubmit.attr('type', 'button').on('click', function(){
      if(this.form.reportValidity()){
        this.form.submit();
      }
    });

    this._init();
  }

  _init() {
    const selectedValue = this.$tabRadios.filter(':checked').val();
    if(selectedValue){
      this.showTab(selectedValue);
    }
  }

  _findInThisContent(selector) {
    const self = this;
    return this.$content.find(selector).filter(function(i){
      // Get only those NOT inside nested tabbed-content
      return $(this).closest('.tabbed-content').get(0) === self.$content.get(0);
    });

  }

  onTabChange(event) {
    let tabValue;

    if(this.contentsAreStageForms){
      // Has Stage forms, use only indexes
      tabValue = this.$tabRadios.index(event.target);
    } else {
      tabValue = event.target.getAttribute('data-show-tab-content');

      if(!tabValue){
        // Event may come inside content (like onInvalid event), get closest content if so
        const $tabContent = event.target.closest('[data-tab-content]');
        tabValue = ($tabContent ? $tabContent.getAttribute('data-tab-content') : tabValue);
      }

      if(!tabValue){
        tabValue = event.target.value;
      }
    }
    this.showTab(tabValue);
  }

  hideAllTabContents() {
    if(!this.contentsAreStageForms || (this.contentsAreStageForms && !this.isEditor)){
      this.$tabContents.css('display', 'none');
    }
  }

  showTab(tabValue) {
    let $tabContent;
    if(typeof tabValue === 'string') {
      $tabContent = this.$tabContents.filter('[data-tab-content="'+tabValue+'"]');
    }
    if(typeof tabValue === 'number') {
      $tabContent = this.$tabContents.eq(tabValue);
    }

    const $currentContent = this.$tabContents.filter(':visible');
    let currentContentHasInvalidFields = false;

    if($tabContent.length && $tabContent.get(0) !== $currentContent.get(0)){
      if($currentContent.length){
        const self = this;
        this.$formElements.each(function(i, $formEl){
          if($currentContent.find($formEl).length){
            if($formEl.reportValidity() === false){
              self.$tabRadios.eq(self.$tabContents.index($currentContent)).click();
              currentContentHasInvalidFields = true;
              return false;
            }
          }
        });
      }
      if(!currentContentHasInvalidFields){
        this.hideAllTabContents();
        $tabContent.css('display', '');
        const $firstFormElement = $tabContent.find('input, select, textarea').filter(':visible').first();
        if($firstFormElement.length){
          $firstFormElement.get(0).focus();
        }
      }
    }
  }
}

export default {
  init: function() {
    let $contents = $('.tabbed-content');

    $contents.each(function(i, el) {
      new TabbedContent(el);
    });
  }
};
